module.exports = __webpack_public_path__ + "images/banner3.cbe8.png";